(function () {
  window.addEventListener("load", function () {
    const anchorLinksList = document.querySelector(".anchor-links__list");

    if (anchorLinksList) {
      anchorLinksList.addEventListener("click", function (event) {
        if (this.classList.contains("open")) {
          this.classList.remove("open");
        } else {
          this.classList.add("open");
        }
      });

      function offset(elt) {
        var rect = elt.getBoundingClientRect(),
          bodyElt = document.body;
        return {
          top: rect.top + bodyElt.scrollTop,
          left: rect.left + bodyElt.scrollLeft,
        };
      }

      const top = offset(anchorLinksList).top;

      window.addEventListener("scroll", function () {
        let y = document.scrollingElement.scrollTop + 100;
        if (y > top) {
          document.body.classList.add("sticky-anchors");
        } else {
          document.body.classList.remove("sticky-anchors");
        }
      });
    }
  });
})();
